import "../page/page.scss";

import * as React from "react";

export default function FixedView({ children }: { children: any }) {
	return <div className="page__fixed-view">{children}</div>;
}
